import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { sessionStorageHelper } from '@stylehaven/components';
import { Observable } from 'rxjs';

@Injectable()
export class ShareApiInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(this.handleShareToken(request));
    }

    protected handleShareToken(request: HttpRequest<any>): HttpRequest<any> {
        const mediahavenApiUrl: string = `mediahaven-rest-api/v2`;
        const isMediaHavenApiRequest: boolean = request.url.includes(mediahavenApiUrl);
        const isCurrentUserRequest: boolean = request.url.includes('users/current');
        const isNonUserApiRequest: boolean = isMediaHavenApiRequest && !isCurrentUserRequest;

        const representationEndpoint: string = `representations`;
        const isRepresentationEndpoint: boolean = request.url.includes(representationEndpoint);

        if (sessionStorageHelper.has('shareToken') && (isNonUserApiRequest || isRepresentationEndpoint)) {
            let headers: HttpHeaders = request.headers || new HttpHeaders();
            let params: HttpParams = request.params || new HttpParams();
            const shareToken: string = sessionStorageHelper.get('shareToken')!;

            headers = headers.set('Authorization', `bearer ${shareToken}`);

            let url: string;
            if (isRepresentationEndpoint) {
                // MED-6655: Use regular endpoint and signature in share context
                url = request.url;
                params = params.set('signature', shareToken);
            } else {
                url = request.url.replace(mediahavenApiUrl, 'mediahaven-rest-api/v2-jwt');
            }

            return request.clone({ url, headers, params });
        }
        return request;
    }
}
